import { Component, Input, OnInit } from '@angular/core';

import { BetBuilderMarket } from '@frontend/sports/betting-offer/feature/model';
import { NativePrice } from '@frontend/sports/odds/feature/native-price';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BetBuilderPickComponent } from '../option-pick/betbuilder-pick.component';
import { OptionComponent } from './option.component';

@Component({
    selector: 'ms-bet-builder-option',
    templateUrl: './bet-builder-option.component.html',
    imports: [BetBuilderPickComponent, IconCustomComponent],
})
export class BetBuilderOptionComponent extends OptionComponent implements OnInit {
    @Input() showMarketAttribute = true;

    betBuilderMarket: BetBuilderMarket;
    betBuilderFixtureId: string;

    ngOnInit(): void {
        this.betBuilderMarket = {
            id: this.option.id,
            name: this.option.description || this.option.name,
            nameSign: '',
            option: {
                id: this.option.id,
                optionPrice: {
                    id: this.option.id,
                    nativePrice: NativePrice.empty(),
                },
                longId: this.option.longId,
                shortId: this.option.shortId,
            },
        };

        this.betBuilderFixtureId = this.event.betBuilderTradingV2FixtureId || this.event.id;
    }
}
